import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-glossary',
    templateUrl: './glossary.component.html',
    styleUrls: ['./glossary.component.css'],
    standalone: false
})

export class GlossaryComponent implements OnInit {

  ngOnInit(): void {
    document.getElementsByTagName('mat-sidenav-content')[0].scrollTo(0, 0);
  }
}
